import { NOT_ASSIGNED } from 'constants/constants';
import React from 'react';
import { dateToIsoString } from 'util/utils';

import usePcrV2 from '../../hooks/usePcrV2';
import VersionHistorySummaryGrid, { SummaryGridRow } from '../VersionHistorySummaryGrid';
import { EpdVersionHistoryData, useEpdVersionHistoryData } from '../utils/EpdVersionHistoryDataContext';
import { VerificationType } from 'services/EpdClient';

const VersionHistoryGeneralInformationDatesGrid: React.FC<{}> = () => {
  const epdVersionHistoryData = useEpdVersionHistoryData();
  const isPcrV2 = usePcrV2();

  const rows = epdVersionHistoryData ? getVersionGeneralInformationDatesRows(epdVersionHistoryData, isPcrV2) || [] : [];
  return <VersionHistorySummaryGrid rows={rows} />;
};

export default VersionHistoryGeneralInformationDatesGrid;

export const getVersionGeneralInformationDatesRows = (data: EpdVersionHistoryData, isPcrV2: boolean): SummaryGridRow[] => {
  const { epdDefinitionInformation, verificationReportInfo } = data || {};

  const possibleRows: (SummaryGridRow | false)[] = [
    verificationReportInfo.verificationType === VerificationType.EPDVerification &&
      !!verificationReportInfo.approvalTimestamp && {
        ord: 1,
        name: 'Approval timestamp',
        value: dateToIsoString(verificationReportInfo.approvalTimestamp) ?? NOT_ASSIGNED,
      },
    !!epdDefinitionInformation.firstPublishedVersionNumber &&
      epdDefinitionInformation.firstPublishedVersionNumber < epdDefinitionInformation.versionNumber && {
        ord: 2,
        name: 'First version date',
        value: dateToIsoString(epdDefinitionInformation.firstPublishedVersionDate) ?? NOT_ASSIGNED,
      },
    {
      ord: 3,
      name: 'Version date',
      value: dateToIsoString(epdDefinitionInformation.versionDate) ?? NOT_ASSIGNED,
    },
    {
      ord: 4,
      name: 'Validity date',
      value: dateToIsoString(epdDefinitionInformation.validityDate) ?? NOT_ASSIGNED,
    },
  ];

  return possibleRows.filter(Boolean) as SummaryGridRow[];
};
